export enum AuthRender {
    Loading,
    Loaded,
    AskCpr,
    TokenDebug, // For testing purposes of the LoginFlow (Delete before production)
}
